import React, { useState, createContext, useContext, useCallback, useMemo } from 'react';

const DownloadAppPopupContext = createContext();

export const DownloadAppPopupProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const contextValue = useMemo(() => ({
    isModalOpen,
    openModal,
    closeModal
  }), [isModalOpen, openModal, closeModal]);

  return (
    <DownloadAppPopupContext.Provider value={contextValue}>
      {children}
    </DownloadAppPopupContext.Provider>
  );
};

export const useDownloadTheAppPopup = () => useContext(DownloadAppPopupContext);

export default DownloadAppPopupContext;
